import { pluralize } from "@sellar-io/common";

type CaseSizeRule = {
  containerType: "can" | "bottle";
  unit: string;
  volume: number;
  quantity: number;
};

export const UnifiedCheckoutCaseSizeRuleStatus = ({
  supplierName,
  rules,
}: {
  supplierName: string;
  rules: CaseSizeRule[];
}) => {
  if (rules.length === 0) return null;

  return (
    <div className="flex flex-col gap-2" role="alert">
      {rules.map((rule) => (
        <div
          className="rounded-lg border border-indigo-200 bg-indigo-100 p-3 text-sm text-indigo-800"
          key={`${rule.containerType}-${rule.volume}-${rule.unit}-${rule.quantity}`}
        >
          {supplierName} <span className="font-semibold">requires</span> you to
          order {rule.volume}
          {rule.unit} {pluralize(rule.containerType, 2)} in full cases of{" "}
          {rule.quantity}
        </div>
      ))}
    </div>
  );
};
